import { API_URL } from "../Config";
import { formatDate } from "../DateUtils";
import {
  GetComplianceInvestigationDetailsAsync,
  IComplianceInvestigationDetails,
} from "../IComplianceInvestigation";
import { ITaskDetails } from "../ITask";
import { GetLicenseDetailsAsync } from "../LicenceDetails";

export interface IComplianceInvestigationActionOrInstruction {
  taskid: string;
  datesubmitted: string;
  type: string;
  category: string;
  subcategory: string;
  status: string;
  observation: string;
  reference: string;
  subject: string;
  description: string;
  regardingobjectid: string;
}

export interface IComplianceInvestigationActionOrInstructionDetails
  extends ITaskDetails {
  complianceInvestidationDetails?: IComplianceInvestigationDetails;
}

export const GetComplianceInvestigationActionsAndInstructionsFetchUrl = (
  regardingObjectId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/Task/listbyregardingobjectid?regardingobject_id=${regardingObjectId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/ci-actions-instructions`;
  }

  return url;
};

export async function GetComplianceInvestigationActionOrInstructionDetailsAsync(
  taskId: string
): Promise<IComplianceInvestigationActionOrInstructionDetails> {
  var url = `${API_URL}/Task/byid?task_id=${taskId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/ci-action-details`;
  }

  var response = await fetch(url);
  var body = <IComplianceInvestigationActionOrInstructionDetails>(
    await response.json()
  );

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);
  const complianceInvestigation = await GetComplianceInvestigationDetailsAsync(
    body.regardingobjectid
  );

  return <IComplianceInvestigationActionOrInstructionDetails>{
    taskid: body.taskid,
    type: body.type,
    licenceid: body.licenceid,
    reference: body.reference,
    status: body.status,
    datesubmitted: formatDate(body.datesubmitted),
    duedate: formatDate(body.duedate),
    subject: body.subject,
    sender: body.sender,
    recipient: body.recipient,
    details: body.details,
    category: body.category,
    subcategory: body.subcategory,
    observation: body.observation,
    description: body.description,
    profileNo: licenceDetails.licenceprofile_number,
    licence_regno: licenceDetails.reg_no,
    regardingobjectid: body.regardingobjectid,
    complianceInvestidationDetails: complianceInvestigation,
  };
}
